module.exports = __webpack_public_path__ + "static/img/img-teh-putri.8d006e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-teh-putri.png
// module id = LovD
// module chunks = 36